/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const ButtonContainer = styled.div`
  margin: 10px 0;
`;
